import React from 'react';
import { MaterialIcon } from './MaterialIcon';
import { getStatusLabel } from '../../utils/helpers';

export type StateBadgeStatus = 'open' | 'in_progress' | 'completed' | 'cancelled' | 'urgent' | 'remote';

interface StateBadgeProps {
  status: StateBadgeStatus;
  size?: 'sm' | 'md';
  className?: string;
}

// Colores + íconos de tokens.jsx / components.jsx (mapa `badge` + StateBadge, Claude Design).
const meta: Record<StateBadgeStatus, { bg: string; fg: string; icon: string; label: string }> = {
  open: { bg: '#e7f5ec', fg: '#1f7a36', icon: 'radio_button_unchecked', label: getStatusLabel('open') },
  in_progress: { bg: '#e3effa', fg: '#0b5394', icon: 'play_circle', label: getStatusLabel('in_progress') },
  completed: { bg: '#ece9f7', fg: '#523a99', icon: 'check_circle', label: getStatusLabel('completed') },
  cancelled: { bg: '#f1eeec', fg: '#6a5d57', icon: 'cancel', label: getStatusLabel('cancelled') },
  urgent: { bg: '#fde8e8', fg: '#b42318', icon: 'priority_high', label: 'Urgente' },
  remote: { bg: '#fbf0e0', fg: '#8a4b00', icon: 'wifi', label: 'Remoto' },
};

export const StateBadge: React.FC<StateBadgeProps> = ({ status, size = 'sm', className = '' }) => {
  const { bg, fg, icon, label } = meta[status];
  const isSmall = size === 'sm';

  return (
    <span
      style={{ backgroundColor: bg, color: fg }}
      className={`inline-flex items-center gap-1 rounded-full font-semibold tracking-tight ${
        isSmall ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'
      } ${className}`}
    >
      <MaterialIcon name={icon} size={isSmall ? 13 : 15} />
      {label}
    </span>
  );
};
